'use client';
import styled from 'styled-components';
import { colors } from '@/styles';

export const AvailableCreditsBanner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  border-bottom: 1px solid ${colors.semantic.information.primary};
  background: ${colors.semantic.information.light};
  padding: 10px 25px;
  text-align: center;
`;
